<template>
  <FadeTransition duration="150">
    <div
      v-if="alertModel.showAlert"
      class="modal-backdrop"
      :class="{
        'modal-backdrop--blur': !$isAndroid,
      }"
    >
      <AndroidAlert v-if="$isAndroid" />
      <IosAlert v-else />
    </div>
  </FadeTransition>
</template>

<script>
import FadeTransition from "@/components/shared/transitions/FadeTransition";
import { mapGetters } from "vuex";
import IosAlert from "@/components/shared/alert/types/IosAlert";
import AndroidAlert from "@/components/shared/alert/types/AndroidAlert";

export default {
  components: {
    IosAlert,
    AndroidAlert,
    FadeTransition,
  },
  name: "Alert.vue",
  computed: {
    ...mapGetters("system", { alertModel: "getAlertModel" }),
    currentRoute() {
      return this.$route.path;
    },
  },
  watch: {
    currentRoute() {
      if (this.alertModel.showAlert) {
        this.$store.dispatch("system/hideAlert");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.modal-backdrop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100000;

  width: 100vw;
  height: 100vh;

  background: #1a1a1a80;

  &--blur {
    backdrop-filter: blur(2px);
  }
}
</style>
